"use strict";

const harden = require( "harden" );



//: @client:
const Olivant = require( "./olivant.support.js" );
//: @end-client

harden( "FAILED", "failed" );
harden( "UNCERTAIN", "uncertain" );
harden( "UNCERTAIN_CODE", 404 );

Olivant.create( "Uncertain", {
	"name": UNCERTAIN,
	"status": FAILED,
	"code": UNCERTAIN_CODE,
	"silent": false,
	"depth": 6,
	"color": "yellow"
} );



// WEBPACK FOOTER //
// uncertain.support.js